import React from 'react';

const CustomizationScoreBar = ({ score = 0, threshold = 0.3 }) => {
  const percentage = Math.min((score / threshold) * 100, 100);
  const isAboveThreshold = score >= threshold;

  const getBarColor = () => {
    if (isAboveThreshold) return 'bg-green-500';
    if (score >= threshold * 0.5) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-gray-700">Customization Score</h3>
        <span className={`text-sm font-medium ${isAboveThreshold ? 'text-green-600' : 'text-gray-600'}`}>
          {(score * 100).toFixed(0)}% {isAboveThreshold ? '— Ready to approve' : `of ${(threshold * 100).toFixed(0)}% required`}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className={`h-2.5 rounded-full transition-all duration-500 ${getBarColor()}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {!isAboveThreshold && (
        <p className="text-xs text-gray-500 mt-1.5">
          Modify, add, or adjust risks to increase your customization score before approving.
        </p>
      )}
    </div>
  );
};

export default CustomizationScoreBar;
